import { render, staticRenderFns } from "./SfSelect.vue?vue&type=template&id=1cf21e95&"
import script from "./SfSelect.vue?vue&type=script&lang=js&"
export * from "./SfSelect.vue?vue&type=script&lang=js&"
import style0 from "./SfSelect.vue?vue&type=style&index=0&id=1cf21e95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports